export const ToggleOptionStatus=(id,fields)=>{
    return `mutation{OptionStatus(id:${id}){${fields.join(" ")}}}`
}


export const createOptionMutatuion=(dto)=>{
    const mut = `mutation{
    createOption(createOptionDto:{opt_text:"${dto.opt_text}",ques_id:${dto.ques_id},is_active:${dto.status}}){
      id
     }
  }`

 return mut

}

export const deleteOptionMutation=(id)=>`mutation{
    deleteOption(id:${id}){id}
  }`
  

export const updateOptionMutation=(id,dto)=>`mutation{
    updateOpt(id:${id},updateOptDto:{opt_text:"${dto.opt_text}",is_active:${dto.status},ques_id:${dto.ques_id}}){opt_text}
    }`